import { render, staticRenderFns } from "./TargetGroupSiteModal.vue?vue&type=template&id=5edfa0ac&"
import script from "./TargetGroupSiteModal.vue?vue&type=script&lang=js&"
export * from "./TargetGroupSiteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports